import { render, staticRenderFns } from "./AutoMessageSettings.vue?vue&type=template&id=0ca6a4f8&scoped=true&"
import script from "./AutoMessageSettings.vue?vue&type=script&lang=js&"
export * from "./AutoMessageSettings.vue?vue&type=script&lang=js&"
import style0 from "./AutoMessageSettings.vue?vue&type=style&index=0&id=0ca6a4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca6a4f8",
  null
  
)

export default component.exports